import cx from 'classnames'

import { PageSectionContextProvider } from '@context/PageSectionContext'

import { colors } from '@styles/_colors'
import styles from './section.module.scss'

type Props = {
  fullHeight?: boolean
  children: React.ReactNode
  backgroundColor?: string
  extraClasses?: string
  sectionExtraClasses?: string
  pageSection: string
  contentMargin?: boolean
  padding?: boolean
}

const Section = ({
  children,
  fullHeight = true,
  backgroundColor = colors.neutral.high.pure,
  extraClasses,
  sectionExtraClasses,
  pageSection,
  contentMargin = true,
  padding = true
}: Props) => (
  <PageSectionContextProvider sectionName={pageSection}>
    <section
      className={cx(styles.section, sectionExtraClasses, {
        [styles['full-height']]: fullHeight,
        [styles['no-padding']]: !padding
      })}
      id={pageSection}
      style={{ backgroundColor }}
    >
      <div className={cx(extraClasses, { 'content-margin': contentMargin })}>{children}</div>
    </section>
  </PageSectionContextProvider>
)

export default Section
